import React, { useContext } from 'react';
import EmptyBackground from '../EmptyBackground';
import BackgroundImage from '../../BackgroundImage';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { ThemeContext, ThemeSkinContext } from '@wix/da-react-context/pkg/ThemeContext';
import { getBackgroundVariant } from '../../redux/helpers';
const LARGE_BACKGROUND_MIN_SIZE = 1300;
function pickBackgroundSrc({ darkBigUrl , darkSmallUrl , lightBigUrl , lightSmallUrl , greenBigUrl =lightBigUrl , greenSmallUrl =lightSmallUrl  }, variant, width) {
    const useLarge = width && width > LARGE_BACKGROUND_MIN_SIZE;
    switch(variant){
        case 'green':
            return useLarge ? greenBigUrl : greenSmallUrl;
        case 'light':
            return useLarge ? lightBigUrl : lightSmallUrl;
        case 'dark':
        default:
            return useLarge ? darkBigUrl : darkSmallUrl;
    }
}
const DefaultStageBackground = ({ width , deviation , background =deviation.background || 'default'  })=>{
    const isMobile = useContext(MobileContext);
    const theme = useContext(ThemeContext);
    const themeSkin = useContext(ThemeSkinContext);
    if (background === 'default' || isMobile) {
        return /*#__PURE__*/ React.createElement(EmptyBackground, null);
    }
    return /*#__PURE__*/ React.createElement(BackgroundImage, {
        src: pickBackgroundSrc(background, getBackgroundVariant(theme, themeSkin), width)
    });
};
DefaultStageBackground.displayName = 'DefaultStageBackground';
export default DefaultStageBackground;
